// Main App - Routing and theme configuration
import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { AuthProvider } from './context/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import ModerationQueue from './pages/ModerationQueue';
import LiveMonitoring from './pages/LiveMonitoring';
import UserManagement from './pages/UserManagement';
import CommunityRooms from './pages/CommunityRooms';
import Analytics from './pages/Analytics';
import SafetySettings from './pages/SafetySettings';
import SupportInbox from './pages/SupportInbox';
import Articles from './pages/Articles';
import Broadcasts from './pages/Broadcasts';
import Subscriptions from './pages/Subscriptions';

// Ovuloom Theme
const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#FF6B9D',
      light: '#FFB8C9',
      dark: '#E55A8A',
    },
    secondary: {
      main: '#4ECDC4',
    },
    success: {
      main: '#96CEB4',
    },
    warning: {
      main: '#FFEAA7',
    },
    error: {
      main: '#D32F2F',
    },
    background: {
      default: '#F8F9FA',
      paper: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 700,
    },
    h6: {
      fontWeight: 600,
    },
  },
  shape: {
    borderRadius: 12,
  },
  components: {
    MuiCard: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiChip: {
      styleOverrides: {
        root: {
          fontWeight: 500,
        },
      },
    },
  },
});

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            {/* Public Route */}
            <Route path="/login" element={<Login />} />

            {/* Protected Routes */}
            <Route
              element={
                <ProtectedRoute>
                  <Layout />
                </ProtectedRoute>
              }
            >
              <Route path="/" element={<Dashboard />} />
              <Route path="/moderation" element={<ModerationQueue />} />
              <Route path="/monitoring" element={<LiveMonitoring />} />
              <Route path="/users" element={<UserManagement />} />
              <Route path="/community" element={<CommunityRooms />} />
              <Route path="/analytics" element={<Analytics />} />
              <Route path="/safety" element={<SafetySettings />} />
              <Route path="/support" element={<SupportInbox />} />
              <Route path="/articles" element={<Articles />} />
              <Route path="/broadcasts" element={<Broadcasts />} />
              <Route path="/subscriptions" element={<Subscriptions />} />
            </Route>

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
